module.exports = __webpack_public_path__ + "static/img/10.7152821.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/zh/10.png
// module id = jjRN
// module chunks = 0